import React from 'react'
import { Button } from '@/ui/components/atoms/Button'
import './UnsavedChangesModal.styles.css'

interface UnsavedChangesModalProps {
  onClose: () => void
  onSave: () => void
  onDiscard: () => void
}

export const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({ 
  onClose, 
  onSave, 
  onDiscard 
}) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2 className="modal-title">Modifications non sauvegardées</h2>
        <p className="modal-description">
          Vous avez des modifications non sauvegardées. Que souhaitez-vous faire ?
        </p>
        <div className="modal-actions">
          <Button variant="secondary" onClick={onDiscard}>
            Annuler les modifications
          </Button>
          <Button variant="primary" onClick={onSave}>
            Sauvegarder
          </Button>
        </div>
      </div>
    </div>
  )
}